import PriceDisplay from '@/components/PriceDisplay';
import { TransText } from '@/i18n/trans/text';
import type { PendingVoucherDTO } from '@/types/dto/agent';
import { Icons, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface VouchersProps {
  vouchers: Array<PendingVoucherDTO>;
}

const Vouchers: FC<VouchersProps> = ({ vouchers }) => {
  return (
    <>
      <div className="flex gap-2 bg-primary-pale px-4 py-3">
        <Icons.wallet className="h-5 w-5 text-primary" />
        <Typography variant="body1-bold">
          <TransText i18nKey="vouchers" />
        </Typography>
      </div>
      <div className="flex flex-col p-4">
        {vouchers.map(({ voucher_code, amount }, key) => (
          <div className="flex justify-between" key={key}>
            <div className="flex gap-2">
              <Icons.ticket className="text-primary" />
              <Typography variant="body2-bold">{voucher_code}</Typography>
            </div>
            <Typography variant="body2-bold" className="flex text-success-text">
              {'-'}
              <PriceDisplay
                amount={amount.amount / 10 ** (amount.scale || 0)}
              />
            </Typography>
          </div>
        ))}
      </div>
    </>
  );
};

export default Vouchers;
